// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table{width:100%}th{background-color:#666;color:#fff}", "",{"version":3,"sources":["webpack://./resources/js/Pages/FileAmounts/Layouts/excel.css"],"names":[],"mappings":"AAAA,MACI,UACJ,CACA,GACI,qBAAyB,CACzB,UACJ","sourcesContent":["table {\n    width: 100%;\n}\nth {\n    background-color: #666666;\n    color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
